// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerLink":"Header_headerLink__EdfYu","noticeBtn":"Header_noticeBtn__o8gnv","burgerBtn":"Header_burgerBtn__y31KG"};